import PolicyDocumentPage from '../../components/policies/PolicyDocumentPage';

function TermsPolicyPage() {
  return (
    <PolicyDocumentPage
      type="terms"
      title="Terms & Conditions"
      eyebrow="Customer policy"
      emptyMessage="No Terms & Conditions have been published yet."
    />
  );
}

export default TermsPolicyPage;
